<template>
  <div class="divFormRecarga">
    <div v-if="processing" class="divLoading">
      <img src="../assets/img/loading.gif">
    </div>
    <form class="formRecarga">
      <div v-if="passagemFuturaObject.STARTDATE > new Date().toLocaleString()" class="box styled-box alert">
        <div class="alerta">
          <h4>REAJUSTE DE TARIFA</h4>
          <p>A partir do dia {{passagemFuturaObject.STARTDATE}}, o valor da passagem será de R${{parseFloat(passagemFuturaObject.AMOUNT).toFixed(2)}}</p>
        </div>
      </div>
      <h2>Passagens</h2>
      <h3>Escolha a quantidade desejada de passagens</h3>
      <div class="styled-radio box">
        <div class="invisible">
          <input  v-for="(option,index) in optionsQuantity" :key="index" type="radio" id="quantity" :value="option" v-model="quantity">
        </div>
        <div class="divRadio noselect" v-for="(option,index) in optionsQuantity" :key="index">
          <span class="noselect" @click="selectInput($event.target)"  appEvent="true"  appEventCategory="recarga" :appEventLabel="`valor clicado: ${option}`" :class="returnClass(index)" >{{option}}</span>
        </div>
      </div>
      <h3>Ou insira o valor da recarga desejada</h3>
      <div class="inputDiv" >
        <input ref="inputDiv" class="styled-input" v-money="money" v-model.number="valorRecarga" placeholder="R$" maxlength="13">
        <div @click="resetQuantity" appEvent="true"  appEventCategory="recarga" :appEventLabel="`valor digitado: ${totalPreco}`" class="button-styled-input">Ok</div>
      </div>
       <span v-if="isAbove" class="formError" >Valor máximo para recarga é R$ 500,00 </span>
      <div class="box styled-box">
        <div class="totalValor">
          <p>Valor Total <span>R$ <strong :class="retornaClasseTamanho">{{ totalPreco }}</strong></span></p>
        </div>
        <div class="totalPassagens">
          <p>Nº de passagens <span><strong>{{retornaQuantidade}}</strong></span></p>
          <p class="fare">No valor de {{precoPassagemFormatada}}</p>
        </div>
      </div>
      <div class="cupom">
        <h3>Cadastre seu cupom</h3>
        <div class="inputDiv" >
          <input ref="inputDiv" class="styled-input" v-model="cupomTexto" maxlength="50">
          <div @click="findCupom" appEvent="true"  appEventCategory="cupom" :appEventLabel="`Buscar Cupom: ${cupomTexto}`" class="button-styled-input">Ok</div>
        </div>
        <div class="cupomBox" v-if="cupomAtivo">
          <div>
            <label>Cashback Total</label>
            <strong>R$ {{ cupomValorCashback }}</strong>
          </div>
          <div>
            <label>Percentual</label>
            <strong>{{ cupomAtivo ? cupomAtivo.percentage : 0 }}%</strong>
          </div>
        </div>
        <span v-if="cupomAtivo && cupomValorAcima" class="formError" >O limite de cashback deste cupom é de R$ {{ cupomAtivo.maxValue.toFixed(2).replace('.',',') }}</span>
        <span v-if="cupomMensagem" class="formError" >{{ cupomMensagem }}</span>
      </div>
      <span v-if="cashBack && retornaQuantidade > 0" class="cashBack"><img style="width: 17px;height: 17px;margin-right: 3%;" src="../assets/img/presente.svg"/>{{retornaCashback }}</span>
      <div class="pagamento box">
        <h2>Pagamento</h2>
        <div class="div-select custom-arrow">
        <select v-model="activePaymentCard" class="styled-select">
          <option :value="null">Escolha seu cartão</option>
          <option :key="i" v-for="(cards,i) in validPaymentCards" :value="cards.id">{{cards.cardNumber}}</option>
        </select>
        </div>
        <!-- <div class="button-styled-select" ><img src="../assets/img/arrow-down-sign-to-navigate.svg"/></div> -->
      </div>

      <div class="promocao box" v-if='promotion'>
        <h2 v-text="promotion.title"></h2>
        <p v-html='promotion.text'></p>
        <label class="vue-check">
          <input type="checkbox" v-model="aceitePromocao" value="1">
          <div class="checkbox"></div>
          <span>Sim, Li e concordo com o <a :href='promotion.ruleLink' target="_blank">regulamento</a></span>
        </label>
      </div>
        <span class="formError" v-if="!validPaymentCards.length" style="display:none">Para efetuar recargas, você precisa cadastrar um cartão de pagamento. Vá até a tela de meus dados</span>     
        <span class="formError" v-else-if="!activePaymentCard" style="display:none">Escolha um cartão de pagamento</span>
        <span class="formError" v-else-if="!totalPreco" style="display:none">Selecione uma quantidade de passagens ou o valor da Recarga</span>
        <span class="formError" v-else-if="!activeCard" style="display:none">Para fazer uma recarga, por favor cadastre um cartão Giro. Vá até a tela de meus dados.</span>
        <span class="formError" v-else-if="!precoPassagem" style="display:none">Sem preço passagem</span>
        <span class="formError" v-else-if="requestError" style="display:none">{{requestError}}</span>
      <div class="form-group">
        
        <a @click="confirm()"  appEvent="true" appEventCategory="recarga" appEventLabel="continuar" class="btn block">recarregar</a>
        
      </div>
      <ConfirmRechargeModal
        :recharge-info="confirmModal.data"
        v-if="confirmModal.open"
        v-on:submit-recharge="submit"
        v-on:close-recharge="confirmModal.open = false"
      />
      <!--<div>
          <p v-if="new Date() >= initialDate && new Date() <= maxDate" style="font-size: 8pt; color: #3D3C3C; padding-bottom: 20px;">
            O valor da passagem cobrada em seu cartão de crédito/débito refere-se a tarifa vigente no momento da recarga.  A partir do dia 02/04 o valor da tarifa é de R$5. Caso tenha recarregado antes e irá utilizar após esta data, o valor a ser debitado em seu cartão Giro (quando passar na catraca) será de acordo com a nova tarifa.
          </p>
      </div>-->
      <v-app>
      <v-dialog @input="close" v-if="this.id && !this.validPaymentCards.length" v-model="dialog.open" max-width="600px">      
          <v-card v-if="dialog.iframe" class="add-cartao">
            <v-card-title style="display:block;" class="styled-header">
              <span class="headline">Adicionar cartão de pagamento</span>
              <span @click="()=>{dialog.open = false;dialog.iframe = null; close()}" class="close">X</span>
            </v-card-title>
            <v-card-text class="resp-container2">
              <iframe class="resp-iframe" scrolling="no" :src="dialog.link" allow="encrypted-media" allowfullscreen></iframe>
            </v-card-text>
          </v-card>
          <v-card class="withoutHeader" v-else>
            <v-card-title>
            </v-card-title>
          <v-card-text >
            <p class="dialog-subtitle">Para efetuar recargas, você precisa cadastrar um cartão de pagamento. Vá até a tela de meus dados.</p>
          </v-card-text>
            <a class="btn block" appEvent="true"  appEventCategory="pop-up" appEventLabel="adicionar cartão de pagamento" @click="createCard(id)" >cadastrar cartão</a>
          <v-card-title>
            </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog @input="close" v-if="this.id && this.urlPayment.open" v-model="urlPayment.open" max-width="1366px" max-height="100%">      
        <v-card class="set-payment">
          <v-card-title style="display:block;" class="styled-header">
            <span class="headline">Confirmação da recarga</span>
            <span @click="()=>{this.urlPayment.open = false;this.urlPayment.iframe = null; close()}" class="close">X</span>
          </v-card-title>
          <v-card-text class="resp-container2">
            <iframe style="border: none" class="resp-iframe" scrolling="yes" width="100%" :height="'700px'" :style="'max-height: 90%'" :src="this.urlPayment.link" allow="encrypted-media" allowfullscreen></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
      </v-app>
    </form>
  </div>
  
</template>

<script>
import {VTextField,VBtn,VDialog,VCard,VCardTitle,VCardText,VApp} from 'vuetify/lib'
import {formatMoney,unFormatMoney,resolvePromise,emitToParent,scrollTop,redirect,maxRecargaValue} from '../helpers/helpers'
import {getCashback,getFare,postOrder,getCupom} from '../services/sbe.service'
import {getActivePromotion} from '../services/promotion.service'
import {save} from '../services/paymentCard.service'
import ConfirmRechargeModal from '../components/ConfirmRechargeModal.vue'

export default {
    name: 'FormRecarga',
    computed:{
      validPaymentCards(){
        let novo = [
          { id: 'novo', cardNumber: 'Novo cartão' },
          { id: 'pix', cardNumber: 'PIX' },
        ];
        return this.paymentCards ? [...novo, ...this.paymentCards.filter(c=>c.cardNumber && c.active)] : novo;
      },
      retornaCashback: function(){
        return `Pague e Receba de Volta R$ ${parseFloat(this.cashBack).toFixed(2).toString().replace(".",",")}`
      },
      isQuantity: function() {
        return this.quantity > 0
      },
      isAbove: function(){
        return (( (unFormatMoney(this.valorRecargaFinal)/100) > maxRecargaValue) && this.input) || (this.isAboveManual)
      },
      isInput: function(){
        
        return ((this.quantity === 0 && this.input) && ((this.valorRecargaFinal) && (unFormatMoney(this.valorRecargaFinal) > 0)))
      },
      totalPreco: function(){
        if(this.isQuantity) {
          this.calculaCashback((this.quantity * this.precoPassagem) / 100)
          return formatMoney(this.quantity * this.precoPassagem) 
        }
          if(this.isInput){
            this.calculaCashback(unFormatMoney(this.valorRecargaFinal) / 100)
            return formatMoney(unFormatMoney(this.valorRecargaFinal))
          }
        return 0
      },
      precoPassagemFormatada: function () {
        return `R$ ${formatMoney(this.precoPassagem)}`
      },
      retornaQuantidade:function () {
        return this.isQuantity ? this.quantity : this.isInput ?  (Math.floor(unFormatMoney(this.valorRecargaFinal)/(this.precoPassagem))) : 0
      },
      retornaClasseTamanho:function(){
        return this.totalPreco.length > 8
      },
      cupomValorAcima: function() {
        if(!this.cupomAtivo || !this.totalPreco) return false;
        let _totalPreco = `${this.totalPreco}`;
        let cashback = (parseFloat(_totalPreco.replace(',','.')) * (this.cupomAtivo.percentage / 100));
        return cashback > this.cupomAtivo.maxValue;
      },
      cupomValorCashback: function() {
        if(!this.cupomAtivo || !this.totalPreco) return '0,00';
        let _totalPreco = `${this.totalPreco}`;
        let cashback = (parseFloat(_totalPreco.replace(',','.')) * (this.cupomAtivo.percentage / 100));
        return cashback > this.cupomAtivo.maxValue ? this.cupomAtivo.maxValue.toFixed(2).replace('.',',') : cashback.toFixed(2).replace('.',',');
      }
    },
    methods:{
      close: function() {
        this.$emit('update-card');
      },
      redirect,
      returnClass:index => ["primeiro",'segundo','terceiro','quarto'][index],
      sucessoCompra:function({data}){
        if(data.urlAuthDebit) {
          this.urlPayment.link = data.urlAuthDebit;
          this.urlPayment.open = true;
          //window.open( data.urlAuthDebit, "_blank"); 
          this.confirmModal = { open: false, data: null };
        } else {
          document.querySelector("body").style.overflow = "initial"
          emitToParent("sucessRecarga",this)
          scrollTop()
          //emitToParent("openPopup",this,{dialog:true,title:"Recarga",message:"Recarga solicitada"})
        }
        this.processing = false
      },
      errCompra:function(){
        this.processing = false
        document.querySelector("body").style.overflow = "initial"
        emitToParent("openPopup",this,{dialog:true,title:"Erro",message:"Recarga não efetuada"})
      },
      confirm: function() {
        this.requestError = null;
        let activeCard = this.paymentCards.filter(v => v.id == this.activePaymentCard);
        if(['pix','novo'].indexOf(this.activePaymentCard) == -1)
          if(!activeCard.length) return;
        
        if(document.querySelector('.formError') || !this.precoPassagem || this.isAbove){
            document.querySelector('.formError').style.display = "block"
          return 
        } 
        this.confirmModal = {
          open: true,
          data: {
            Value: this.totalPreco,
            CreditCard: this.activePaymentCard == 'novo' ? 'Novo cartão' : (this.activePaymentCard == 'pix' ? 'PIX' : activeCard[0].cardNumber.toString()),
            Promotion: this.promotion || null,
            AceitePromocao: this.aceitePromocao || false
          }
        }
      },
      submit:function(){
        this.confirmModal = { open: false, data: null };
        this.requestError = null
        if(document.querySelector('.formError') || !this.precoPassagem || this.isAbove){
            document.querySelector('.formError').style.display = "block"
          return
        } 
        const formData = new FormData();
        var cupomId = this.cupomAtivo ? this.cupomAtivo.id : null;
        if(cupomId) {
          formData.append("CupomId", cupomId.toString());
        }
        formData.append("Value",this.totalPreco)
        formData.append("CardId",this.activeCard.cardNumber.toString())
        formData.append("CardPayId",this.activePaymentCard.toString())
        if(this.promotion) {
          formData.append("PromotionId",this.promotion.id.toString())
          formData.append("PromotionAcceptance",this.aceitePromocao)
        } else {
          formData.append("PromotionAcceptance", false)
        }
        // document.querySelector("body").style.overflow = "hidden"
        this.processing = true
        resolvePromise(postOrder(formData),this.sucessoCompra,this.errCompra,this)
      },
      setIframeLink:function({data}){
        this.dialog.link = data.url
        this.dialog.iframe= true
      },
      createCard:function(id){
      const formData = new FormData();
      formData.append("UserId",id)
      resolvePromise(save(formData),this.setIframeLink,console.log,this)
      
      },
      setaPrecoPassagem:function({data}){
        const atual = data.find(a=>a.CURRENT)
        this.precoPassagem = Math.round(parseFloat(atual.AMOUNT) * 100)
        this.passagemFuturaObject = data.filter(({CURRENT,STARTDATE})=>!CURRENT &&  STARTDATE > new Date().toLocaleString()).reduce(function (a, b) { return a < b ? a : b; }); 
      },
      deselectDivRadio:function(){
        Array.from(document.querySelectorAll(".divRadio span")).forEach(el=>{
            el.classList.remove('active')
            el.parentElement.classList.remove('active')
            document.querySelector(".invisible input[value='"+el.textContent+"']").checked = false
          })
      },
      deactivateInput: function(){ 
        this.valorRecarga =  "R$ 0,00"
        document.querySelector('.inputDiv').classList.remove('active')
        this.defaultInputValue = true
        this.valorRecargaFinal = 0
      },
      selectInput: function(span){
        this.deselectDivRadio()
        this.deactivateInput()
         this.isAboveManual = false
        span.classList.toggle('active')
        span.parentElement.classList.toggle('active')
        const input = document.querySelector(".invisible input[value='"+span.textContent+"']")
        input.checked = true
        this.quantity = parseInt(span.textContent)
      },
      resetQuantity: function({target}){
        this.defaultInputValue = false
        if((unFormatMoney(this.valorRecarga) / 100) <= maxRecargaValue){
          this.valorRecargaFinal = this.valorRecarga
          this.isAboveManual = false
        } 
        else{
          this.valorRecargaFinal = 0
           this.isAboveManual = true
        }
        this.input = true
        this.cashBack = 0
        target.parentElement.classList.add("active")
        this.quantity = 0
        this.deselectDivRadio();
      },
      calculaCashback: function(valor){
        resolvePromise(getCashback(valor),({data}) => this.cashBack = data.cashbackAmount,console.log,this)
      },
      retornaTarifa: function(){
        resolvePromise(getFare(),this.setaPrecoPassagem,console.log,this)
      },
      retornaProgramaDePontos: function() {
        resolvePromise(getActivePromotion(),({data}) => {
          this.promotion = data;  
          this.aceitePromocao = data.lastRecharge;
        },console.log,this)
      },
      findCupom: function() {
        this.cupomMensagem = null;
        this.cupomAtivo = null;
        if(this.cupomTexto) {
          getCupom(this.cupomTexto).then((d) => {
            this.cupomAtivo = d.data;
          }).catch((err) => {
            if(err && err.response && err.response.status == 404) {
              this.cupomMensagem = "Cupom inválido.";
            } else {
              this.cupomMensagem = "Erro no retorno de dados do servidor. Verifique a conexão com a internet.";
            }
          });
        }
      }
    },
    components:{
        VTextField,
        VBtn,
        VDialog,
        VCard,
        VCardTitle,
        VCardText,
        VApp,
        ConfirmRechargeModal
    },
    props:{
      paymentCards:{
        type:Array
      },
      id:{
        type:Number
      },
      activeCard:{
        type:Object
      }
    },
    created(){
      this.retornaTarifa()
      this.urlPayment = { open: false, link: null };
      this.retornaProgramaDePontos();
    },
    data(){
     return{
        dialog:{
          open:true,
          iframe:false,
          link:null
        },
        urlPayment: { open: false, link: null },
        promotion: false,
        aceitePromocao: false,
        confirmModal: { open: false, data: null },
        initialDate:new Date("04/02/2020 00:00"),
        maxDate:new Date("04/30/2020 23:59"),
        defaultInputValue:false,
        isAboveManual:false,
        input:false,
        processing:false,
        requestError:null,
        activePaymentCard:null,
        quantity:0,
        valorRecarga: 0,
        valorRecargaFinal:0,
        precoPassagem:null,
        passagemFuturaObject:{
          AMOUNT:null,
          CURRENT:null,
          STARTDATE:null
        },
        cashBack:null,
        optionsQuantity: [ 5,10,15,20 ],
        cupomTexto: '',
        cupomMensagem: '',
        cupomAtivo: null, // { id: 0, coupon: '', maxValue: 0, percentage: 0 }
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false,
          }
      }
    }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/formRecarga.scss";
  .promocao {
    h2 { color: #ED1164; }
    a { color: #ED1164; }
   }
  .vue-check { cursor: pointer; display: flex; align-items: center; margin: 20px 0;}
  .vue-check p { margin: 10px 0; }
  .vue-check input { display: none }
  .vue-check .checkbox {  margin-right: 10px; transition: 200ms; position:relative; width: 70px; height: 30px; border-radius: 15px; background: grey;}
  .vue-check .checkbox::before { transition: 200ms; position: absolute; content: ""; left: 2px; height: 26px; width: 26px; top: 2px; display: block; background: white; border-radius: 100%; }
  .vue-check input:checked + .checkbox { background: #ED1164; }
  .vue-check input:checked + .checkbox::before { left: calc(100% - 28px);}
  .cupomBox { margin-top: 10px; padding: 10px; border-radius: 5px; background: #969696; color: white; display: flex; }
  .cupomBox > div { text-align: center; flex: 1; display: flex; flex-direction: column; row-gap: 5px; }
  .cupomBox > div strong { font-size: 18px;}
</style>
